<template>
  <div id="chart-container" style="height: 500px;width: 100%; background-color: #FFFFFF;"></div>
</template>

<script>
  require('amcharts3')
  require('amcharts3/amcharts/serial')
  require('amcharts3/amcharts/themes/light')
  export default {
    name: 'FakeStats',
    mounted () {
      const params = {
        'type': 'serial',
        'categoryField': 'category',
        'sequencedAnimation': false,
        'startEffect': 'easeOutSine',
        'color': '#CCC',
        'fontFamily': 'Roboto',
        'fontSize': 10,
        'categoryAxis': {
          'gridPosition': 'start',
          'axisColor': '#CCC',
          'gridColor': '#CCC'
        },
        'chartCursor': {
          'enabled': true,
          'animationDuration': 0.33,
          'cursorAlpha': 0.53,
          'cursorColor': '#000'
        },
        'trendLines': [],
        'graphs': [
          {
            'balloonText': '[[title]] of [[category]]:[[value]]',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletBorderColor': '#FF8000',
            'bulletColor': '#FFFFFF',
            'columnWidth': 0,
            'fillColors': '#FF8000',
            'fontSize': 8,
            'id': 'AmGraph-1',
            'lineColor': '#FF8000',
            'lineThickness': 2,
            'title': 'RESERVATIONS',
            'valueField': 'column-1'
          },
          {
            'balloonText': '[[title]] of [[category]]:[[value]]',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletBorderColor': '#FFD668',
            'bulletColor': '#FFFFFF',
            'fillAlphas': 0.48,
            'fillColors': '#FFD668',
            'id': 'AmGraph-2',
            'lineAlpha': 0.22,
            'lineColor': '#FFD668',
            'lineThickness': 2,
            'title': 'ACTES',
            'valueField': 'column-2'
          },
          {
            'bullet': 'round',
            'fillColors': '#D15858',
            'id': 'AmGraph-3',
            'lineColor': '#D15858',
            'title': 'ANNULATIONS',
            'valueField': 'column-4'
          }
        ],
        'guides': [],
        'valueAxes': [
          {
            'id': 'ValueAxis-1',
            'axisColor': '#CCC',
            'gridAlpha': 1,
            'gridColor': '#E8E8E8',
            'title': ''
          }
        ],
        'allLabels': [],
        'balloon': {
          'borderAlpha': 0.12,
          'borderThickness': 1,
          'shadowAlpha': 0
        },
        'legend': {
          'enabled': true,
          'marginRight': 0,
          'markerLabelGap': 6,
          'spacing': 0,
          'useGraphSettings': true
        },
        'titles': [
          {
            'id': 'Title-1',
            'size': 15,
            'text': ''
          }
        ],
        'dataProvider': [
          {
            'category': 'Janvier',
            'column-1': 8,
            'column-2': 5,
            'column-4': 2
          },
          {
            'category': 'Février',
            'column-1': 4,
            'column-2': 7,
            'column-4': 1
          },
          {
            'category': 'Mars',
            'column-1': 5,
            'column-2': 3,
            'column-4': 2
          },
          {
            'category': 'Avril',
            'column-1': '',
            'column-2': 3,
            'column-4': ''
          },
          {
            'category': 'Mai',
            'column-1': '',
            'column-2': '1',
            'column-4': null
          },
          {
            'category': 'Juin',
            'column-1': '',
            'column-2': '',
            'column-4': null
          },
          {
            'category': 'Juillet',
            'column-1': '',
            'column-2': '',
            'column-4': null
          },
          {
            'category': 'Aout',
            'column-1': '',
            'column-2': '',
            'column-4': null
          },
          {
            'category': 'Septembre',
            'column-1': '',
            'column-2': '',
            'column-4': null
          },
          {
            'category': 'Octobre',
            'column-1': '',
            'column-2': '',
            'column-4': null
          },
          {
            'category': 'Novembre',
            'column-1': '',
            'column-2': '',
            'column-4': null
          },
          {
            'category': 'Décembre',
            'column-1': '',
            'column-2': '',
            'column-4': null
          }
        ]
      }
      let container = document.getElementById('chart-container')
      window.AmCharts.makeChart(container, params)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/company/CompanyVuePanels/FakeStats.vue